export const DRAWER_WIDTH = 300;

export const INPUT_MIN_WIDTH = '230px';
export const INPUT_MIN_PADDING = '10px';